import { BinaryConfig, IBinaryConfig } from '@/features/binaryConfig';
import { CheckBinaryConfig } from '@/features/binaryConfig/check';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { useAppStore } from '@/shared/stores/app';
import { createContext, useState } from 'react';
import { EnumOfflineMode, FEED_BINARY_CONFIG, FEED_OFFLINE_MODE, IS_BINARY } from '../../constants';

interface IContextData {
  theme: string | null;
}

export const BinaryConfigContext = createContext({} as IContextData);

export function BinaryConfigProvider({ children }: { children: React.ReactNode }) {
  const { backendLoaded } = useAppStore();

  const [binaryConfig] = useLocalStorage<IBinaryConfig | null>(FEED_BINARY_CONFIG, null);
  const [offlineMode] = useLocalStorage<EnumOfflineMode | null>(FEED_OFFLINE_MODE, null);

  const [authored, setAuthored] = useState(false);

  function handleAuthored() {
    setAuthored(true);
  }

  if (IS_BINARY && (offlineMode === null || binaryConfig?.error)) {
    if (!binaryConfig || binaryConfig.error) {
      return <BinaryConfig />;
    }

    if (!authored && !backendLoaded) {
      return <CheckBinaryConfig onSuccess={handleAuthored} />;
    }
  }

  return <BinaryConfigContext.Provider value={{ theme: 'value' }}>{children}</BinaryConfigContext.Provider>;
}
